export default __webpack_public_path__ + "static/Profile-Siliconinsider-7abaac6fb492e337d926b67f4588216c.png";